<template>
    <div>
        <TextInput
            @blur="$emit('blur')"
            v-model="input"
            type="text"
            :styling="styling"
            :value="value ?? modelValue"
            :label="label"
            :validation="validation"
            :disabled="disabled"
            :readonly="readonly"
            :autocomplete="autocomplete"
            :name="name"
            :list="optionSlug"
        ></TextInput>
        <datalist :id="optionSlug">
            <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
        </datalist>
    </div>
</template>

<script>
import TextInput from './TextInput.vue';

export default {
    data() {
        return {
            input: this.modelValue,
        };
    },
    props: {
        options: { type: Array },
        optionSlug: { type: String },

        label: { type: String, required: true },
        name: { type: String, required: false },
        value: { required: false },
        modelValue: { type: String, required: false },
        readonly: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        autocomplete: { type: String, default: 'off' },
        styling: { required: false },
        validation: { type: Object, required: false },
    },
    watch: {
        input(value) {
            this.$emit('update:modelValue', value);
        },
    },
    components: {
        TextInput,
    },
};
</script>

<style>

</style>
